import Guru from "../../../../../components/categories/siakad/lms/data_guru/Home";
export default function Home() {
  
  return (
    <Guru />
  );
}
